import { NgModule } from '@angular/core';

import { SubscriptionService } from './services/subscription.service';

@NgModule({
  providers: [SubscriptionService]
})
export class DomainSubscriptionModule {}
